import { getLogger } from "@expert/logging";
import { getRootDispatcher } from "@/analytics";
import { getSelectedSessionId } from "@/sdk";
import type { Enrollment, EnrollmentResponse } from "../types";
import { EnrollmentStatus } from "../types";
import { getSalesApiClient } from "./api";

const logger = getLogger({
    module: "enrollment",
    supportTeam: "sales",
});

export const createEnrollment = async (enrollment: Enrollment) => {
    const childLogger = logger.child({ productOfferId: enrollment.productOfferId, sessionId: getSelectedSessionId() });
    try {
        const salesApi = getSalesApiClient();
        childLogger.info("Making enrollment request");
        const enrollmentEndPoint = "v2/enrollment";
        const result = await salesApi
            .post(enrollmentEndPoint, { json: enrollment })
            .json<EnrollmentResponse | EnrollmentResponse[]>();
        childLogger.info("Finished enrollment request");
        const results = Array.isArray(result) ? result : [result];
        results.forEach((r) => {
            void getRootDispatcher().dispatchBusinessEvent("GetEnrollmentStatus", {
                ProductOfferId: enrollment.productOfferId,
                enrollmentStatus: r.enrollmentStatus,
                StatusOrigin: "ASP",
                productSku: r.productSku,
                confirmationCode: enrollment.confirmationCode,
            });
        });
        return result;
    } catch (err: unknown) {
        void getRootDispatcher().dispatchBusinessEvent("EnrollmentError", {
            Status: "LAMBDA_ERROR",
            ProductOfferId: enrollment.productOfferId,
            Error: err,
            productSku: enrollment.productSku,
        });

        childLogger.error({ err, enrollment }, "enrollment api call failed");
        return { enrollmentStatus: EnrollmentStatus.Error };
    }
};
